(function () {
  'use strict';

  if (window.UnifiedDashboard) {
    return;
  }

  const VERSION = '1.1.0';

  /*
   * ------------------------------------------------------------
   * HELPERS
   * ------------------------------------------------------------
   */

  function getConfig() {
    return (
      window.UnifiedTrackingConfig ||
      {}
    );
  }

  function isDebugEnabled() {
    return (
      getConfig().debug === true
    );
  }

  function clone(value) {
    try {
      return JSON.parse(
        JSON.stringify(value)
      );
    } catch (error) {
      return value;
    }
  }

  function nowIso() {
    return new Date()
      .toISOString();
  }

  function safeCall(
    target,
    methodName,
    fallback
  ) {
    if (
      !target ||
      typeof target[methodName] !==
        'function'
    ) {
      return fallback;
    }

    try {
      return target[
        methodName
      ]();
    } catch (error) {
      return fallback;
    }
  }

  /*
   * ------------------------------------------------------------
   * FRAMEWORK
   * ------------------------------------------------------------
   */

  function getFramework() {
    const tracking =
      window.UnifiedTracking;

    return {
      framework_version:
        getConfig().version ||
        '',

      tracking_version:
        tracking &&
        tracking.version
          ? tracking.version
          : '',

      deployment:
        getConfig().deployment ||
        '',

      environment:
        getConfig().environment ||
        '',

      debug:
        getConfig().debug ===
        true,

      consent_required:
        getConfig()
          .consentRequired ===
        true,

      generated_at:
        nowIso()
    };
  }

  /*
   * ------------------------------------------------------------
   * HEALTH
   * ------------------------------------------------------------
   */

  function getHealth() {
    if (
      !window.UnifiedHealth ||
      typeof window.UnifiedHealth
        .evaluate !==
        'function'
    ) {
      return {
        status:
          'unavailable'
      };
    }

    try {
      return window.UnifiedHealth
        .evaluate();
    } catch (error) {
      return {
        status:
          'failed',

        reason:
          'health_evaluation_failed'
      };
    }
  }

  /*
   * ------------------------------------------------------------
   * CONSENT
   * ------------------------------------------------------------
   */

  function getConsent() {
    const consent =
      window.UnifiedConsent;

    if (!consent) {
      return {
        loaded:
          false,

        ready:
          false
      };
    }

    const state =
      safeCall(
        consent,
        'getState',
        {}
      );

    return Object.assign(
      {
        loaded:
          true
      },
      state || {}
    );
  }

  /*
   * ------------------------------------------------------------
   * PROVIDERS
   * ------------------------------------------------------------
   */

  function getProviders() {
    const manager =
      window
        .UnifiedProviderManager;

    if (
      !manager ||
      typeof manager.getStatus !==
        'function'
    ) {
      return {};
    }

    try {
      return manager.getStatus();
    } catch (error) {
      return {
        error:
          'provider_status_failed'
      };
    }
  }

  /*
   * ------------------------------------------------------------
   * JOURNEY
   * ------------------------------------------------------------
   */

  function getJourney() {
    const journey =
      window.UnifiedJourney;

    if (!journey) {
      return {
        available:
          false
      };
    }

    return {
      available:
        true,

      summary:
        safeCall(
          journey,
          'getSummary',
          {}
        ),

      entries:
        safeCall(
          journey,
          'getJourney',
          []
        )
    };
  }

  /*
   * ------------------------------------------------------------
   * ERRORS
   * ------------------------------------------------------------
   */

  function getErrors() {
    const errors =
      window.UnifiedErrors;

    if (!errors) {
      return {
        available:
          false
      };
    }

    return {
      available:
        true,

      stats:
        safeCall(
          errors,
          'getStats',
          {}
        ),

      recent:
        typeof errors.getRecent ===
          'function'
          ? errors.getRecent(20)
          : []
    };
  }

  /*
   * ------------------------------------------------------------
   * PERFORMANCE
   * ------------------------------------------------------------
   */

  function getPerformance() {
    const performanceMonitor =
      window.UnifiedPerformance;

    if (!performanceMonitor) {
      return {
        available:
          false
      };
    }

    return {
      available:
        true,

      stats:
        safeCall(
          performanceMonitor,
          'getStats',
          {}
        ),

      active:
        safeCall(
          performanceMonitor,
          'getActive',
          []
        )
    };
  }

  /*
   * ------------------------------------------------------------
   * BUS
   * ------------------------------------------------------------
   */

  function getBus() {
    const bus =
      window.UnifiedBus;

    if (!bus) {
      return {
        available:
          false
      };
    }

    return {
      available:
        true,

      stats:
        safeCall(
          bus,
          'getStats',
          {}
        ),

      history:
        safeCall(
          bus,
          'getHistory',
          []
        )
    };
  }

  /*
   * ------------------------------------------------------------
   * DEBUG
   * ------------------------------------------------------------
   */

  function getDebug() {
    const debug =
      window.UnifiedDebug;

    if (!debug) {
      return {
        available:
          false
      };
    }

    return {
      available:
        true,

      history:
        safeCall(
          debug,
          'getHistory',
          []
        )
    };
  }

  /*
   * ------------------------------------------------------------
   * LISTENERS
   * ------------------------------------------------------------
   */

  function getListeners() {
    if (
      window.UnifiedHealth &&
      typeof window.UnifiedHealth
        .getListenerStatus ===
        'function'
    ) {
      try {
        return window.UnifiedHealth
          .getListenerStatus();
      } catch (error) {
        // Fallback below.
      }
    }

    const listenerMap = {
      phone:
        window
          .UnifiedPhoneListener,

      email:
        window
          .UnifiedEmailListener,

      form:
        window
          .UnifiedFormListener,

      visibility:
        window
          .UnifiedVisibilityListener,

      cta:
        window
          .UnifiedCtaListener,

      newsletter:
        window
          .UnifiedNewsletterListener,

      share:
        window
          .UnifiedShareListener,

      whatsapp:
        window
          .UnifiedWhatsappListener,

      social:
        window
          .UnifiedSocialListener
    };

    const result = {};

    Object.keys(
      listenerMap
    ).forEach(
      function (name) {
        const listener =
          listenerMap[name];

        if (!listener) {
          result[name] = {
            loaded:
              false,

            started:
              false
          };

          return;
        }

        let status = {};

        if (
          typeof listener.getStatus ===
            'function'
        ) {
          try {
            status =
              listener.getStatus() ||
              {};
          } catch (error) {
            status = {};
          }
        }

        result[name] =
          Object.assign(
            {
              loaded:
                true
            },
            status
          );
      }
    );

    return result;
  }

  /*
   * ------------------------------------------------------------
   * MARKUP
   * ------------------------------------------------------------
   */

  function getMarkup() {
    let sections = [];
    let ctas = [];

    try {
      sections =
        Array.from(
          document.querySelectorAll(
            '[data-ut-section]'
          )
        ).map(
          function (element) {
            return {
              section:
                element.getAttribute(
                  'data-ut-section'
                ) || '',

              service:
                element.getAttribute(
                  'data-ut-service'
                ) || '',

              id:
                element.id ||
                ''
            };
          }
        );
    } catch (error) {
      sections = [];
    }

    try {
      ctas =
        Array.from(
          document.querySelectorAll(
            '[data-ut-cta]'
          )
        ).map(
          function (element) {
            return {
              label:
                element.getAttribute(
                  'data-ut-label'
                ) ||
                (
                  element.textContent ||
                  ''
                )
                  .trim()
                  .replace(
                    /\s+/g,
                    ' '
                  )
                  .slice(
                    0,
                    100
                  ),

              target:
                element.getAttribute(
                  'data-ut-target'
                ) || '',

              service:
                element.getAttribute(
                  'data-ut-service'
                ) || '',

              section:
                element.closest(
                  '[data-ut-section]'
                )
                  ? element
                      .closest(
                        '[data-ut-section]'
                      )
                      .getAttribute(
                        'data-ut-section'
                      )
                  : ''
            };
          }
        );
    } catch (error) {
      ctas = [];
    }

    return {
      sections:
        sections,

      ctas:
        ctas,

      section_count:
        sections.length,

      cta_count:
        ctas.length
    };
  }

  /*
   * ------------------------------------------------------------
   * CONFIG SUMMARY
   * ------------------------------------------------------------
   */

  function getConfigSummary() {
    const config =
      getConfig();

    return {
      version:
        config.version ||
        '',

      deployment:
        config.deployment ||
        '',

      environment:
        config.environment ||
        '',

      debug:
        config.debug ===
        true,

      consent_required:
        config.consentRequired ===
        true,

      events:
        config.events
          ? Object.keys(
              config.events
            )
          : [],

      pages:
        config.pages
          ? Object.keys(
              config.pages
            )
          : [],

      providers:
        config.providers ||
        {}
    };
  }

  /*
   * ------------------------------------------------------------
   * COMPLETE SNAPSHOT
   * ------------------------------------------------------------
   */

  function getSnapshot() {
    return {
      framework:
        getFramework(),

      config:
        getConfigSummary(),

      health:
        getHealth(),

      consent:
        getConsent(),

      providers:
        getProviders(),

      listeners:
        getListeners(),

      markup:
        getMarkup(),

      journey:
        getJourney(),

      errors:
        getErrors(),

      performance:
        getPerformance(),

      bus:
        getBus(),

      debug:
        getDebug()
    };
  }

  /*
   * ------------------------------------------------------------
   * COMPACT STATUS
   * ------------------------------------------------------------
   */

  function getStatus() {
    const snapshot =
      getSnapshot();

    return {
      framework_version:
        snapshot.framework
          .framework_version,

      deployment:
        snapshot.framework
          .deployment,

      environment:
        snapshot.framework
          .environment,

      health:
        snapshot.health
          .status ||
        'unknown',

      consent_ready:
        snapshot.consent
          .ready === true,

      analytics_allowed:
        snapshot.consent
          .analytics_allowed ===
        true,

      marketing_allowed:
        snapshot.consent
          .marketing_allowed ===
        true,

      tracked_sections:
        snapshot.markup
          .section_count,

      tracked_ctas:
        snapshot.markup
          .cta_count,

      journey_entries:
        snapshot.journey &&
        snapshot.journey
          .summary
          ? snapshot.journey
              .summary.entries ||
            0
          : 0
    };
  }

  /*
   * ------------------------------------------------------------
   * PRINT
   * ------------------------------------------------------------
   */

  function print() {
    const snapshot =
      getSnapshot();

    const status =
      getStatus();

    console.group(
      '[Unified Dashboard] Bianchi'
    );

    console.log(
      'Framework:',
      status.framework_version
    );

    console.log(
      'Deployment:',
      status.deployment
    );

    console.log(
      'Environment:',
      status.environment
    );

    console.log(
      'Health:',
      status.health
    );

    console.log(
      'Consent ready:',
      status.consent_ready
    );

    console.log(
      'Analytics allowed:',
      status.analytics_allowed
    );

    console.log(
      'Marketing allowed:',
      status.marketing_allowed
    );

    console.log(
      'Tracked sections:',
      status.tracked_sections
    );

    console.log(
      'Tracked CTAs:',
      status.tracked_ctas
    );

    console.log(
      'Providers:',
      snapshot.providers
    );

    console.log(
      'Listeners:',
      snapshot.listeners
    );

    console.log(
      'Journey:',
      snapshot.journey
    );

    console.log(
      'Errors:',
      snapshot.errors
    );

    console.log(
      'Performance:',
      snapshot.performance
    );

    console.groupEnd();

    return clone(
      snapshot
    );
  }

  /*
   * ------------------------------------------------------------
   * CONVENIENCE METHODS
   * ------------------------------------------------------------
   */

  function printHealth() {
    if (
      window.UnifiedHealth &&
      typeof window.UnifiedHealth
        .print ===
        'function'
    ) {
      return window.UnifiedHealth
        .print();
    }

    console.warn(
      '[Unified Dashboard] UnifiedHealth is unavailable.'
    );

    return null;
  }

  function printJourney() {
    if (
      window.UnifiedJourney &&
      typeof window.UnifiedJourney
        .printJourney ===
        'function'
    ) {
      return window.UnifiedJourney
        .printJourney();
    }

    return [];
  }

  function printErrors() {
    if (
      window.UnifiedErrors &&
      typeof window.UnifiedErrors
        .printHistory ===
        'function'
    ) {
      return window.UnifiedErrors
        .printHistory();
    }

    return [];
  }

  function printPerformance() {
    if (
      window.UnifiedPerformance &&
      typeof window.UnifiedPerformance
        .printHistory ===
        'function'
    ) {
      return window.UnifiedPerformance
        .printHistory();
    }

    return [];
  }

  function printDebug() {
    if (
      window.UnifiedDebug &&
      typeof window.UnifiedDebug
        .printHistory ===
        'function'
    ) {
      return window.UnifiedDebug
        .printHistory();
    }

    return [];
  }

  /*
   * ------------------------------------------------------------
   * RESET DIAGNOSTICS
   *
   * Does NOT alter consent.
   * Does NOT alter provider configuration.
   * ------------------------------------------------------------
   */

  function clearDiagnostics() {
    if (
      window.UnifiedBus &&
      typeof window.UnifiedBus
        .clearHistory ===
        'function'
    ) {
      window.UnifiedBus
        .clearHistory();
    }

    if (
      window.UnifiedDebug &&
      typeof window.UnifiedDebug
        .clearHistory ===
        'function'
    ) {
      window.UnifiedDebug
        .clearHistory();
    }

    if (
      window.UnifiedErrors &&
      typeof window.UnifiedErrors
        .clear ===
        'function'
    ) {
      window.UnifiedErrors
        .clear();
    }

    if (
      window.UnifiedPerformance &&
      typeof window.UnifiedPerformance
        .clear ===
        'function'
    ) {
      window.UnifiedPerformance
        .clear();
    }

    console.info(
      '[Unified Dashboard] Diagnostic histories cleared.'
    );

    return true;
  }

  /*
   * ------------------------------------------------------------
   * PUBLIC API
   * ------------------------------------------------------------
   */

  window.UnifiedDashboard = {
    version:
      VERSION,

    getSnapshot:
      getSnapshot,

    getStatus:
      getStatus,

    getFramework:
      getFramework,

    getConfig:
      getConfigSummary,

    getHealth:
      getHealth,

    getConsent:
      getConsent,

    getProviders:
      getProviders,

    getListeners:
      getListeners,

    getMarkup:
      getMarkup,

    getJourney:
      getJourney,

    getErrors:
      getErrors,

    getPerformance:
      getPerformance,

    getBus:
      getBus,

    getDebug:
      getDebug,

    print:
      print,

    printHealth:
      printHealth,

    printJourney:
      printJourney,

    printErrors:
      printErrors,

    printPerformance:
      printPerformance,

    printDebug:
      printDebug,

    clearDiagnostics:
      clearDiagnostics
  };

  if (
    isDebugEnabled()
  ) {
    console.info(
      '[Unified Dashboard] Dashboard API initialized',
      {
        version:
          VERSION
      }
    );
  }
})();